import { Component, OnInit, Input, HostListener, Output } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { DataTableDirective } from 'angular-datatables'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { AuthenticationService } from 'src/app/services/authentication.service'

@Component({
	selector: 'app-header-detail',
	templateUrl: './header-detail.component.html'
})
export class HeaderDetailComponent implements OnInit {
	@Input()
	public dtElement: DataTableDirective

	public list: any = []
	public searchValue: string
	public isOpen: boolean
	public openDialog: boolean = false
	public companyName: string = localStorage.getItem('companyName')

	constructor(private router: Router, private authenticationService: AuthenticationService) {}

	@Input()
	public sessionUser

	public ngOnInit(): void {
		this.searchValue = ''
		this.isOpen = false
		this.sessionUser = getLoggedUser()
	}

	public logout(): void {
		this.authenticationService.logoff()
	}

	public handleSearch(): void {
		if (this.dtElement) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				dtInstance.search(this.searchValue, false, true, false)
				dtInstance.draw()
			})
		}
	}

	public openModal(): void {
		this.openDialog = true
		this.isOpen = false
	}

	public openDetails(): void {
		this.router.navigate(['/panel/userDetail'])
	}

	public close(): void {
		this.openDialog = false
	}

	@HostListener('click', ['$event'])
	public onClick(event: any): void {
		event.stopPropagation()
		const target: any = event.target
		const { isOpen } = this

		if (target.id !== 'dropdown' && target.id !== 'dropdown-item') {
			this.isOpen = false

			return
		}

		if (target.id === 'dropdown' && isOpen) {
			this.isOpen = false

			return
		}

		this.isOpen = true

		return
	}
}
